import { render, staticRenderFns } from "./MicrobiologyResults.vue?vue&type=template&id=436590f8&scoped=true"
import script from "./MicrobiologyResults.vue?vue&type=script&lang=js"
export * from "./MicrobiologyResults.vue?vue&type=script&lang=js"
import style0 from "./MicrobiologyResults.vue?vue&type=style&index=0&id=436590f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "436590f8",
  null
  
)

export default component.exports